import * as React from 'react';

import { enumSidecarStatus } from '@rematter/frontend-lib-api-client';
import { useAtomValue } from 'jotai';

import { $p2pRelayInfo } from './relayInfo';
import { useSidecarConnection } from './useSidecarConnection';

type Params = {
  sidecar:
    | {
        id: string;
        peerId: string | null | undefined;
        multiaddrs: string[];
        status: string;
      }
    | null
    | undefined;
  onConnectionFailed?: () => void;
};

export function useHardwareSidecarConnection({
  sidecar,
  onConnectionFailed,
}: Params) {
  const relayInfoQuery = useAtomValue($p2pRelayInfo);
  const relayMultiaddrs = React.useMemo(
    () => relayInfoQuery.data?.multiaddrs ?? [],
    [relayInfoQuery.data?.multiaddrs],
  );

  const directMultiaddrs = React.useMemo(
    () => sidecar?.multiaddrs ?? [],
    [sidecar?.multiaddrs],
  );

  const result = useSidecarConnection({
    sidecarId: sidecar?.id,
    peerId: sidecar?.peerId,
    directMultiaddrs,
    relayMultiaddrs,
    enabled:
      sidecar?.status === enumSidecarStatus.Provisioned && !!sidecar?.peerId,
  });

  React.useEffect(() => {
    if (result.connectionFailed) onConnectionFailed?.();
  }, [result.connectionFailed, onConnectionFailed]);

  return result;
}
